const live_classes_en = require('./live_classes.json')
export default live_classes_en